// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailVerifyWrapper_wrapper__kMRYf","emailVerifiedIcon":"EmailVerifyWrapper_emailVerifiedIcon__Va-M3","emailVerifiedDone":"EmailVerifyWrapper_emailVerifiedDone__WRXQc"};